export enum EnumCalendarViewType {
    /**
     * 일별 보기
     */
    Daily = 'day',

    /**
     * 주별 보기
     */
    Week = 'week',

    /**
     * 월별 보기
     */
    Month = 'month',
}